import {
  BORDER_COLOR_SHADE_2,
  CHARCOAL_GREY,
  PRIMARY_BLUE,
  FITOGRAM_BLUE_FADED_9,
  TEXT_SUBHEADER,
} from '~/Constants/Colors.constants';
import { TRANSITION_MATERIAL } from '~/Constants/CSS.constants';
import { FONT_SIZE_MEDIUM, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const EventScheduleTimeSeriesItemStyles = (disabled: boolean) =>
  makeStyles(() => ({
    mainContainer: {
      position: 'relative',
    },
    eventScheduleItemContainer: {
      borderRadius: '3px 3px 0 0',
      opacity: disabled ? 0.6 : 1,
      '&$selected': {
        border: `thin solid ${PRIMARY_BLUE}`,
      },
      '&:last-of-type': {
        '& > button': {
          border: 'none',
        },
      },
    },
    eventScheduleItemHeader: {
      width: '100%',
      padding: '10px 15px 10px 15px',
      borderBottom: `thin solid ${BORDER_COLOR_SHADE_2}`,
      fontSize: FONT_SIZE_SMALLISH,
      lineHeight: '20px',
      color: TEXT_SUBHEADER,
      transition: `background-color ${TRANSITION_MATERIAL}, border ${TRANSITION_MATERIAL}`,
      display: 'block',
      textAlign: 'left',

      '&$selected': {
        backgroundColor: FITOGRAM_BLUE_FADED_9,
        padding: '10px 15px',
        borderBottom: 'none',
        width: '100%',
        margin: 0,
      },
    },
    selected: {},
    eventScheduleItemTitle: {
      display: 'block',
      fontWeight: 'bold',
      fontSize: FONT_SIZE_MEDIUM,
      color: CHARCOAL_GREY,
      transition: `color ${TRANSITION_MATERIAL}`,
      '&$selected': {
        color: PRIMARY_BLUE,
      },
    },
    eventScheduleItemSubtitle: {
      display: 'block',
      fontWeight: 300,
      transition: `color ${TRANSITION_MATERIAL}`,
      '&$selected': {
        color: PRIMARY_BLUE,
      },
    },
    eventScheduleEditorWrapperDesktop: {
      padding: 15,
    },
    infoContainer: {
      right: 15,
      zIndex: 1,
      height: 60,
      display: 'flex',
      position: 'absolute',
      alignItems: 'center',
    },
  }));
